import { Bits } from './bits';

export enum CampaignBuilderPermissions {
	CanAccessCampaignBuilder = Bits.Bit1,
	SmartCreateView = Bits.Bit2
}
